export default __webpack_public_path__ + "static/media/yellow-inner.474f1987.svg";